import axios from 'axios';
import { toast } from 'react-toastify';
import { IS_LOADING, UPCOMING_SERIES_LIST_SUCCESS, UPCOMING_SERIES_LIST_ERROR, ACTIVE_SERIES_LIST_SUCCESS, ACTIVE_SERIES_LIST_ERROR, SERIES_ACTION_SUCCESS, SERIES_ACTION_ERROR, SERIES_DATE_SUCCESS, SERIES_DATE_ERROR } from './Type';
import { baseUrlPostGres } from '../constant';
import { apiHeader } from './ApiHeader';
import 'react-toastify/dist/ReactToastify.css';
import HandleError from '../HandleError';
import { apiVersion } from 'src/utils/apiVersion';

export const GetUpcomingSeriesListAction = (page, size, type) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/series/list?page=${page}&limit=${size}&type=${type}`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: UPCOMING_SERIES_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: UPCOMING_SERIES_LIST_ERROR,
                payload: errors
            })
        })
}

export const ResetGetUpcomingSeriesListAction = () => async (dispatch) => {
    dispatch({
        type: UPCOMING_SERIES_LIST_SUCCESS,
        payload: {}
    })
}

export const GetActiveSeriesListAction = (page, size, type) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/series/active_list?page=${page}&limit=${size}&type=${type}`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: ACTIVE_SERIES_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: ACTIVE_SERIES_LIST_ERROR,
                payload: errors
            })
        })
}


export const SeriesChangeStatusAction = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/series/active-inactive`, body, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: SERIES_ACTION_SUCCESS,
                payload: response.data
            })
            response.data.status == false ? toast.error(response.data.message, { theme: "colored" }) : toast.success(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: SERIES_ACTION_ERROR,
                payload: errors
            })
            toast.error(errors.error.errorMessage.id.message, { theme: "colored" })
        })
}

export const SeriesFootballChangeStatusAction = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/match/series/football/active_inactive`, body, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: SERIES_ACTION_SUCCESS,
                payload: response.data
            })
            response.data.status == false ? toast.error(response.data.message, { theme: "colored" }) : toast.success(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: SERIES_ACTION_ERROR,
                payload: errors
            })
            toast.error(errors.error.errorMessage.id.message, { theme: "colored" })
        })
}

export const ResetSeriesChangeStatusAction = () => async (dispatch) => {
    dispatch({
        type: SERIES_ACTION_SUCCESS,
        payload: {}
    })
}


export const SeriesDateAction = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/series_datetime_pool`, body, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: SERIES_DATE_SUCCESS,
                payload: response.data
            })
            toast.success(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: SERIES_DATE_ERROR,
                payload: errors
            })
            toast.error(errors.response.data.message, { theme: "colored" })
        })
}